<cb-loading-page loadingMessage="We are processing your session">
</cb-loading-page>
